// extracted by mini-css-extract-plugin
export default {"dataRow":"fustdetail_dataRow__LRYjr"};